import { Container } from "@mui/material";
import React from "react";
import ProofRadios from "../components/Forms/ProofRadios";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import "../Style/Theme/index.css";

export default function DocumentProof() {
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={5} />
        <IntroCard
          title="Upload any business proof document"
          subtitle="Get a loan amount of ₹50,000 & more by uploading one of these documents"
          img="/assets/doc.svg"
        />
        <ProofRadios />
      </Container>
    </>
  );
}
